import { render } from "./_AddressMain.vue?vue&type=template&id=2ed2f013"
import script from "./_AddressMain.vue?vue&type=script&lang=js"
export * from "./_AddressMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__